import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';

const InternalSidebar = ({ active, open, onClose }) => {
  const { logout } = useAuth();

  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const resolvedActive = active === 'account-section' ? 'account' : active;

  const linkClass = (key, extras = []) =>
    `flex items-center gap-3 text-sm font-medium transition-colors ${
      [key, ...extras].includes(resolvedActive)
        ? 'text-slate-900 font-semibold'
        : 'text-slate-600 hover:text-slate-900'
    }`;

  return (
    <aside
      data-component="internal-sidebar"
      className={`bg-white/90 backdrop-blur-sm shadow-lg lg:w-64 w-72 max-w-full lg:static lg:translate-x-0 fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ${
        open ? 'translate-x-0' : '-translate-x-full'
      } lg:min-h-screen px-6 py-8 flex flex-col`}
    >
      <div className="lg:hidden flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="text-slate-500 hover:text-slate-700 text-xl"
        >
          <i className="bi-x-lg"></i>
        </button>
      </div>
      <div className="flex-1 flex flex-col gap-10">
        <div className="flex items-center">
          <img src="/img/branded/logob.png" alt="Stackfy" className="h-10 w-auto" />
        </div>

        <nav className="flex flex-col gap-3 text-sm font-medium text-slate-600">
          <a href="/dashboard" className={linkClass('dashboard')} onClick={handleLinkClick}>
            <i className="bi-house-door-fill text-lg"></i> Home
          </a>
          <a href="/accounts" className={linkClass('accounts')} onClick={handleLinkClick}>
            <i className="bi-wallet2 text-lg"></i> Carteiras
          </a>
          <a href="/wallets" className={linkClass('wallet')} onClick={handleLinkClick}>
            <i className="bi-bookmark-check text-lg"></i> Wallet
          </a>
          <a href="/transact/deposit" className={linkClass('deposit')} onClick={handleLinkClick}>
            <i className="bi-download text-lg"></i> Depositar
          </a>
          <a href="/transact/transfer" className={linkClass('withdraw')} onClick={handleLinkClick}>
            <i className="bi-upload text-lg"></i> Sacar
          </a>
          <a href="/transact" className={linkClass('transact')} onClick={handleLinkClick}>
            <i className="bi-arrow-left-right text-lg"></i> Comprar/Vender
          </a>
          <a href="/transactions" className={linkClass('transactions')} onClick={handleLinkClick}>
            <i className="bi-receipt-cutoff text-lg"></i> Extrato
          </a>
          <a href="/account" className={linkClass('account', ['account-section'])} onClick={handleLinkClick}>
            <i className="bi-person text-lg"></i> Minha Conta
          </a>
        </nav>
      </div>

      <div className="pt-6 space-y-4">
        <div className="rounded-xl bg-white border border-slate-200 px-5 py-4 text-sm shadow-sm">
          <div className="font-semibold text-slate-800 mb-2">Telegram</div>
          <p className="text-slate-500 text-xs mb-3">Tem dúvidas ou está com problemas? Fale conosco!</p>
          <a
            href="https://link.stackfy.app/websupport"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[#0255F1] text-white px-4 py-2 text-xs font-semibold hover:bg-[#0144CC] transition-colors"
          >
            <i className="bi-telegram"></i> Contactar
          </a>
        </div>

        <button
          type="button"
          onClick={logout}
          className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200"
        >
          <i className="bi-box-arrow-right text-lg"></i> Logout
        </button>
      </div>
    </aside>
  );
};

InternalSidebar.propTypes = {
  active: PropTypes.oneOf([
    'dashboard',
    'accounts',
    'wallet',
    'transact',
    'deposit',
    'withdraw',
    'transactions',
    'account',
    'account-section',
  ]),
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

InternalSidebar.defaultProps = {
  active: undefined,
  open: true,
  onClose: undefined,
};

export default InternalSidebar;


